export const DashAdd = ({ style, className }) => {
  return (
    <svg
      style={style}
      className={className}
      width="26" 
      height="26" 
      viewBox="0 0 26 26"
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13 25V1" stroke="#323130" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M1 13H25" stroke="#323130" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};